import Cookies from "js-cookie";

const getConfig = (data?: any) => {
    const token = Cookies.get("Token");

    const isFormData = data instanceof FormData;

    const headers: Record<string, string> = {};
    if (!isFormData) {
        headers["Content-Type"] = "application/json";
    }

    if (token) {
        headers["Authorization"] = "Token " + token;
    }

    return {
        headers,
        withCredentials: true,
    };
};

const getSuperAdminPublicConfig = (data?: any) => {
    const token = process.env.REACT_APP_SUPERPUBLICADMIN_PASSWORD

    const isFormData = data instanceof FormData;

    const headers: Record<string, string> = {};
    if (!isFormData) {
        headers["Content-Type"] = "application/json";
    }

    if (token) {
        headers["Authorization"] = "Token " + token;
    }

    return {
        headers,
        withCredentials: true,
    };
};


export { getConfig, getSuperAdminPublicConfig };